import { RouteConfig } from 'vue-router'

class RouterUtils {
  // 将子项加入到父项内形成树型结构
  static appendSubRoute(rootItem: RouteConfig, subItem: RouteConfig) {
    const rootCode: string = rootItem.meta ? rootItem.meta.code : undefined
    const subCode: string = subItem.meta ? subItem.meta.code : undefined

    if (rootCode && subCode && RouterUtils.isParentCode(rootCode, subCode)) {
      if (
        RouterUtils.getCodeLevel(rootCode) + 1 ===
        RouterUtils.getCodeLevel(subCode)
      ) {
        if (!rootItem.children) {
          rootItem.children = []
        }
        rootItem.children.push(subItem)
      } else {
        const parentItem: RouteConfig | undefined = RouterUtils.getParentItem(
          rootItem,
          subCode
        )
        if (parentItem == undefined) {
          console.error(
            'code错误无法找到父级---path:' +
            rootItem.path +
            ' subPath:' +
            subItem.path
          )
        } else {
          if (!parentItem.children) {
            parentItem.children = []
          }
          parentItem.children.push(subItem)
        }
      }
    } else {
      console.error(
        'code错误---path:' + rootItem.path + ' subPath:' + subItem.path
      )
    }
  }

  // 将路由转换成菜单
  static routeToMenuTree(routeList: RouteConfig[]): RouteConfig[] {
    const menuList: RouteConfig[] = []
    for (let i = 0; i < routeList.length; i++) {
      const item = routeList[i]
      if (item.meta && item.meta.hidden) {
        continue
      }
      menuList.push(item)
    }
    return menuList
  }

  // 是否是上下级编码
  static isParentCode(code: string, subCode: string): boolean {
    if (code == subCode.substr(0, code.length)) {
      return true
    } else {
      return false
    }
  }

  static getParentItem(
    rootItem: RouteConfig,
    subCode: string,
    section = 2
  ): RouteConfig | undefined {
    let tempItem: any = {
      children: [rootItem]
    }
    for (let i = section; i < subCode.length; i = i + section) {
      const code = subCode.substr(0, i)
      let findItem = false
      for (let k = 0; k < tempItem.children.length; k++) {
        const item: RouteConfig = tempItem.children[k]
        if (item.meta && item.meta.code && code === item.meta.code) {
          findItem = true
          tempItem = item
          break
        }
      }
      if (findItem === false) {
        return undefined
      } else if (
        code == subCode.substr(0, subCode.length - section) &&
        findItem
      ) {
        return tempItem
      }
    }
    return undefined
  }

  // 根据编码的长度获取级数
  static getCodeLevel(code: string, section = 2): number {
    if (code === '') {
      return 0
    }
    if (code.length % 2 !== 0) {
      console.error('code错误位数不对---code=' + code + ' section=' + section)
      return 0
    }
    return code.length / section
  }

  // 根据编码的长度获取级数 级别的字符位00表示不计算
  static getCodeLevelEmptyCode(
    code: string,
    section = 2,
    emptyCode = '00'
  ): number {
    if (code === '') {
      return 0
    }
    let level = 0
    for (let i = 0; i < code.length; i = i + section) {
      if (i + section > code.length) {
        break
      }
      if (code.substr(i, section) === emptyCode) {
        return level
      }
      level = level + 1
    }
    return level
  }

  // 从access里获取菜单图标
  static getMenuIcon(access: any, menuCode: string) {
    if (!access) {
      // console.log(access)
      return ''
    }
    for (let i = 0; i < access.length; i++) {
      if (access[i].menuCode === menuCode) {
        return access[i].menuIcon
      }
    }
    return ''
  }

  // 根据code 获取accessData里的子项
  static getAccessRouteItemCode(code: string, accessData: Array<any>, section = 2): Array<string> {
    if (RouterUtils.getCodeLevel(code) !== 1) {
      console.error('getAccessRouteItemCode参数code=' + code + ' 不是一级菜单')
      return []
    }
    const codeList: Array<string> = []
    for (let i = 0; i < accessData.length; i++) {
      if (accessData[i].menuCode.substr(0, section) === code) {
        codeList.push(accessData[i].menuCode)
      }
    }
    return codeList
  }

  static getFullCodeList(code: string, section = 2): Array<string> {
    if (!code) {
      return []
    }
    if (code.length % section !== 0) {
      return []
    }
    const codeList: Array<string> = []
    for (let i = 2; i <= code.length; i = i + 2) {
      const item = code.substring(0, i)
      codeList.push(item)
    }
    return codeList
  }
}

export default RouterUtils
